import { render, staticRenderFns } from "./labelManage.vue?vue&type=template&id=7f4da21e&scoped=true"
import script from "./labelManage.vue?vue&type=script&lang=js"
export * from "./labelManage.vue?vue&type=script&lang=js"
import style0 from "./labelManage.vue?vue&type=style&index=0&id=7f4da21e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f4da21e",
  null
  
)

export default component.exports